import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import { Controller } from "react-hook-form";
import { useFormConfigContext } from "./ConfigFormContext";
import { ExtractionQueryPath } from "./ConfigUtils";

type EnumFieldPath =
  | `${ExtractionQueryPath}.enum_values`
  | `${ExtractionQueryPath}.custom_schema.${number}.enum_values`;

const EnumField = ({
  isReadOnly,
  queryPath,
}: {
  isReadOnly: boolean;
  queryPath: EnumFieldPath;
}) => {
  const { control } = useFormConfigContext();
  return (
    <Controller
      name={queryPath}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          multiple
          freeSolo
          options={[]}
          value={value || []}
          onChange={(event, newValue) => {
            onChange(newValue);
          }}
          renderTags={(value: readonly string[], getTagProps) =>
            value.map((option: string, index: number) => (
              <Chip
                label={option}
                {...getTagProps({ index })}
                disabled={isReadOnly}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Options"
              placeholder="Entrez des valeurs et appuyez sur Entrée"
              size="small"
            />
          )}
        />
      )}
    />
  );
};

export default EnumField;
